<template>
  <div :class="[isFold ? 'fold' : 'unFold', 'collapse']">
    <div class="collapse__header">
      <div class="collapse__title">
        <img
          alt="arrow"
          src="@/assets/images/cookie-management/arrow-down.svg"
          @click="isFold = !isFold"
        />
        <h5>{{ title }}</h5>
      </div>
      <slot name="button" />
    </div>
    <div class="collapse__desc">
      <slot
        v-if="true"
        name="description"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'

interface IProps {
  /** 标题 */
  title: string
}

/* 配置组件默认值 */
defineProps<IProps>()

const isFold = ref(true)
</script>
<style lang="less">
.collapse {
  background: var(--color-active);
  border-radius: 4px;
  padding: 14px 12px;
  margin-top: 12px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: #000;
      line-height: 16px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h5 {
      font-size: 14px;
      color: #000;
      margin-left: 12px;
      font-weight: 600;
      line-height: 18px;
    }
  }
}

.unFold {
  img {
    transform: rotate(0deg);
    transition: transform 0.2s ease-out;
  }

  .collapse__desc {
    max-height: 600px;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }
}

.fold {
  img {
    transform: rotate(-90deg);
    transition: transform 0.2s ease-out;
  }

  .collapse__desc {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }
}
</style>
